import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import SettingPage from "../pages/SettingPage";

const CustomBottomSetting = ({ reSettingKaruta, customSetting, setCustomSetting, isOpen, setOpen, customHudaList, play }) => {
    return (
        <div>
            <div
                style={{ width: "100%" }}
                onClick={() => {
                    console.log("CustomBottomSheet Clicked");
                }}
            >
                <BottomSheet
                    onDismiss={() => {
                        setOpen(false);
                    }}
                    open={isOpen}
                    snapPoints={({ minHeight, maxHeight }) => [
                        maxHeight * 9, //최대
                    ]}
                >
                    <SettingPage
                        setOpen={setOpen}
                        reSettingKaruta={reSettingKaruta}
                        customSetting={customSetting}
                        setCustomSetting={setCustomSetting}
                        customHudaList={customHudaList}
                        play={play}
                    ></SettingPage>
                </BottomSheet>
            </div>
        </div>
    );
};

export default CustomBottomSetting;
